<template>
<div>
    <div class="personal-center container">
      <!-- 头部信息 -->
      <header class="mb-5 text-center" style="padding-top:80px">
        <h4 class="text-dark mb-3">个人学习中心</h4>
       
      </header>
  
      <!-- 课程卡片列表 -->
      <section class="mb-5">
        <h5 class="section-title mb-4">
          <i class="bi bi-journal-bookmark me-2"></i>我的课程
        </h5>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          <div 
            class="col"
            v-for="(course, index) in courses"
            :key="'course-' + index"
          >
            <div class="card h-100 course-card shadow-sm">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-3">
                  <h5 class="card-title">{{ course.title }}</h5>
                  <!-- <span class="badge bg-primary">{{ course.category }}</span> -->
                </div>
                <p class="card-text text-muted">{{ course.description }}</p>
                <!-- <div class="progress mb-3">
                  <div 
                    class="progress-bar"
                    :class="course.progress < 50 ? 'bg-warning' : 'bg-success'"
                    :style="{ width: course.progress + '%' }"
                  >{{ course.progress }}%</div>
                </div> -->
                <button class="btn btn-outline-info btn-sm" style="float:right" @click="enter('homework',index+1)">课后作业</button>
                <button class="btn btn-outline-info btn-sm" style="float:right;margin-right:10px" @click="enter('classes',index+1)">进入课堂</button>
                
              </div>
            </div>
          </div>
        </div>
      </section>
  
      <!-- 练习系统卡片列表 -->
      <section class="mb-5">
        <h5 class="section-title mb-4">
          <i class="bi bi-code-square me-2"></i>练习系统
        </h5>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          <div 
            class="col"
            v-for="(practice, index) in practices"
            :key="'practice-' + index"
          >
            <div class="card h-100 practice-card shadow-sm">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-3">
                  <h5 class="card-title">{{ practice.title }}</h5>
             
                </div>
                <p class="card-text text-muted">{{ practice.description }}</p>
                <div class="d-flex justify-content-between align-items-center" style="justify-content: flex-end !important">
                    <button 
                    class="btn btn-outline-info btn-sm"
                    @click="enter('exercises',index+1)"
                  >
                    开始练习
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mb-5">
        <h5 class="section-title mb-4">
          <i class="bi bi-code-square me-2"></i>模考系统
        </h5>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          <div 
            class="col"
            v-for="(exam, index) in exams"
            :key="'exam-' + index"
          >
            <div class="card h-100 practice-card shadow-sm">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-3">
                  <h5 class="card-title">{{ exam.title }}</h5>

                </div>
                <p class="card-text text-muted">{{ exam.description }}</p>
                <div class="d-flex justify-content-between align-items-center" style="justify-content: flex-end !important">
                 
                  <button 
                    class="btn btn-outline-info btn-sm"
                    @click="enter('exam',index+1)"
                  >
                    开始模考
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> 
    </div>
    <bottom></bottom>

    <div class="modal fade" id="realDialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">选择题目</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div v-for="t in examSet">
                <div style="padding-left:10px;margin-bottom:5px;">{{ t.year }}</div>
               <button @click="realExercise(t.year,q)" v-for="q in t.questions" class="btn btn-info btn-sm" style="width:85px;margin-bottom:10px;margin-left:2px;margin-right:2px">{{ q }}</button>
              </div>
              </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="practiceDialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">选择模拟题目</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div v-for="t in practiceSet">
                <div style="padding-left:10px;margin-bottom:5px;">{{ t.year }}</div>
               <button @click="realExercise(t.year,q)" v-for="q in t.questions" class="btn btn-info btn-sm" style="width:85px;margin-bottom:10px;margin-left:2px;margin-right:2px">{{ q }}</button>
              </div>
              </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="typeDialog" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">选择练习模块</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div style="display: flex;justify-content: start;flex-wrap: wrap;">
               <button @click="tagExercise(t)" v-for="t in tags" class="btn btn-info btn-sm" style="width:150px;margin-bottom:10px;margin-left:2px;margin-right:2px">{{ t.tag_name }}</button>
              </div>
              </div>
            <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
                <button type="button" class="btn btn-primary" style="background:#04b2c5;border-color:#04b2c5" @click="onLogin()">登录</button>
            </div> -->
            </div>
        </div>
    </div>
</div>
  </template>
  
  <script>
  import bottom from '@/components/bottom.vue';
  export default {
    components: {
      bottom
    },
    data() {
      return {
        config:{

        },
        examSet:[
        {
            year:"2025",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2024",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2023",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2022",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2021",
            questions:['FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"2020",
            questions:['MCQ','FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          }
        ],
        practiceSet:[
          {
            year:"Series-1",
            questions:['MCQ','FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
          {
            year:"Series-2",
            questions:['MCQ','FRQ-1','FRQ-2','FRQ-3','FRQ-4']
          },
        ],
        tags:[],
        userName: "开发者小明",
        courses: [
          {
            title: "基础启航班",
            category: "",
            description: "学习Java语言的基础知识，基本算法",
            progress: 65
          },
          {
            title: "强化提高班",
            category: "",
            description: "学习编程知识的综合运用，助力AP",
            progress: 30
          },
          {
            title: "考前冲刺班",
            category: "",
            description: "面向AP考试重点题型，重点学习练习",
            progress: 80
          }
        ],
        practices: [
          
          {
            title: "每日一练",
            description: "精选题库，任意组题",
            status: "进行中",
            lastPractice: "",
            available: true
          },
          {
            title: "收藏突破",
            description: "错题，收藏题目反复练习突破",
            status: "未开通",
            lastPractice: "-",
            available: false
          },
          {
            title: "专项突破",
            description: "16大知识模块，分类突破",
            status: "已开通",
            lastPractice: "",
            available: true
          }
        ],
        exams: [
          {
            title: "真题模考",
            description: "往年真题，模拟考试",
            status: "已开通",
            lastPractice: "",
            available: true
          },
          // {
          //   title: "实战模考",
          //   description: "千锤百炼，实战模拟",
          //   status: "进行中",
          //   lastPractice: "",
          //   available: true
          // }
        ]
      };
    },
    mounted(){
        var user = localStorage.getItem('user');
        if(user && user != null && user != ''){
            var userObj = JSON.parse(user);
            this.$http.get('https://programapi.dctechonline.cn/api/user/config/'+userObj.Mobile).then(res=>{
                this.config = res.data;
            })
        }
        else{
            location.href = '/';
        }
        this.$http.get('https://apapi.dctechonline.cn/api/tags').then(res=>{
          this.tags = res.data;
        })
    },
    methods: {
      realExercise(year,q){
        $("#realDialog").modal("hide");
        $("#practiceDialog").modal("hide");
        if(q =='MCQ'){
          window.open('/real-mcq?year='+year+'&q='+q)
        
        }
        else{
          window.open('/real-frq?year='+year+'&q='+q)
          //this.$router.push();
        }
      },
      tagExercise(t){
        $("#typeDialog").modal("hide");
        this.$router.push('/exercises?id=3&tag='+t.tag_id);
      },
        enter(subject,index){
            var arr = this.config[subject];
            console.log(arr);

            if(subject == 'exercises' && index == 3){
              $("#typeDialog").modal("show");
              return;
            }

            if(subject=='exam' && index == 1){
              $("#realDialog").modal("show");
              return;
            }

            if(subject=='exam' && index == 2){
              $("#practiceDialog").modal("show");
              return;
            }

            if(arr && arr != null){
                if(arr.indexOf(index)>=0){
                    this.$router.push('/'+subject+'?id='+index);
                }
                else{
                    alert('未开通');
                }
            }
            else{
                alert('未开通');
            }
        },
        practiceStatusClass(practice) {
            return {
            'bg-success': practice.status === '已开通',
            'bg-warning': practice.status === '进行中',
            'bg-secondary': practice.status === '未开通'
            };
        }
    }
  };
  </script>
  
  <style scoped>
  .personal-center {

    min-height: 80vh;
  }
  
  .user-info {
    background: white;
    padding: 2rem;
    border-radius: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .section-title {
 
    font-weight: normal;
    text-align: left;
    font-size:16px;
    color:#04b2c5;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #04b2c5;
  }
  
  .card {
    border: none;
    border-radius: 12px;
    transition: transform 0.3s ease;
  }
  
  .card:hover {
    transform: translateY(-5px);
    background:#f8f8f8;
  }
  
  .course-card .progress {
    height: 8px;
    border-radius: 4px;
    background-color: #e9ecef;
  }
  
  .practice-card .badge {
    font-size: 0.8rem;
    padding: 0.5em 0.75em;
  }
  
  .btn {
    border-radius: 20px;
    padding: 0.375rem 1.25rem;
  }
  </style>